class LineStorage {
    lineStorage(input: string): string[] {
        let sentences = input.split(". ");

        return sentences;
    }
}

export default LineStorage;